import React from 'react'

function Proj() {
    return (
        <div className='bbox' id='proj'>
            <h2 className='sbox-title'>PROJECTS</h2>
            <h3>
                COMING SOON!
            </h3>
        </div>
    )
}

export default Proj